var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupFiles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.19995 2.1V8.70001C3.19995 8.99175 3.31584 9.27154 3.52213 9.47783C3.72842 9.68412 4.00821 9.80001 4.29995 9.80001H8.69996C8.9917 9.80001 9.27149 9.68412 9.47778 9.47783C9.68407 9.27154 9.79996 8.99175 9.79996 8.70001V3.8831C9.79994 3.73656 9.77064 3.5915 9.71378 3.45644C9.65693 3.32138 9.57365 3.19904 9.46886 3.0966L7.64561 1.3135C7.4401 1.11256 7.16412 1.00004 6.87671 1H4.29995C4.00821 1 3.72842 1.11589 3.52213 1.32218C3.31584 1.52847 3.19995 1.80826 3.19995 2.1V2.1Z",
    stroke: "#EA3458",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60001 9.80001V10.9C7.60001 11.1917 7.48411 11.4715 7.27782 11.6778C7.07153 11.8841 6.79174 12 6.50001 12H2.1C1.80826 12 1.52847 11.8841 1.32218 11.6778C1.11589 11.4715 1 11.1917 1 10.9V4.85C1 4.55826 1.11589 4.27847 1.32218 4.07218C1.52847 3.86589 1.80826 3.75 2.1 3.75H3.2",
    stroke: "#EA3458",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupFiles);
export default __webpack_public_path__ + "static/media/groupFiles.31c5a787850bb0c1d546c425786baa9f.svg";
export { ForwardRef as ReactComponent };